export const sliderItems = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1581591524425-c7e0978865fc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    title: '"Click. Rent. Return."',
    desc: "Rent almost anything, delivery or collection",
  },
];
let testImage =
  "https://images.unsplash.com/photo-1472803828399-39d4ac53c6e5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGdyZXl8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=60&q=60";

export const categories = [
  {
    id: 1,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0373863a4-ce9a-4fe4-ba37-dca83d1dbc40",
    title: "Books",
    cat: "books",
    desc: "Rent books in almost every genre. Rent Fiction, Childrens, Non-fiction, you name it. Chances are, someone is lending it on Rentoodle.",
    subcat: [
      "Art, Architecture & Photography",
      "Biography",
      "Business, Finance & Law",
      "Children's Books",
      "Comics & Graphic Novels",
      "Computers & Internet",
      "Crime, Thrillers & Mystery",
      "Education Studies & Teaching",
      "Erotica",
      "Fiction",
      "Food & Drink",
      "Gay & Lesbian",
      "Health, Family & Lifestyle",
      "History",
      "Home & Garden",
      "Horror",
      "Humour",
      "Languages",
      "Mind, Body & Spirit",
      "Poetry, Drama & Criticism",
      "Reference",
      "Religion & Spirituality",
      "Romance",
      "School Books",
      "Science & Nature",
      "Science Fiction & Fantasy",
      "Scientific, Technical & Medical",
      "Society, Politics & Philosophy",
      "Sports, Hobbies & Games",
      "Travel & Holiday",
      "University Textbooks",
      "Young Adult",
    ],
  },

  {
    id: 3,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0f2aa225f-f4a3-419e-b471-1e7a49a4f2eb",
    title: "Womens Fashion",
    cat: "womens-fashion",
    desc: "Rent designer dresses, jackets, sunglasses and more. Find a range of womens designer clothing to rent, including shoes and accessories. Choose from and hire luxury designer clothes from top brands. From figure hugging dresses to ballroom gowns.",
    subcat: [
      "Tops & Blouses",
      "Designer Dresses",
      "Evening Dresses",
      "Midi Dresses",
      "Maxi Dresses",
      "Mini Dresses",
      "Day Dresses",
      "Printed Dresses",
      "Long Sleeve Dresses",
      "Floral Dresses",
      "Gowns",
      "Party Dresses",
      "Wedding Dresses",
      "Bridesmaid Dresses",
      "Prom Dresses",
      "Open Back Dresses",
      "Embellished Dresses",
      "Knee-length Dresses",
      "Bodycon Dresses",
      "Cutout Dresses",
      "Maternity Dresses",
      "Designer Handbags",
      "Mini bags",
      "Satchels",
      "Tote Bags",
      "Clutch Bags",
      "Belts",
      "Sunglasses",
      "Sneakers",
      "Sandals",
      "Pumps",
      "High heels",
      "Flat shoes",
      "Mules",
      "Ankle boots",
      "Ballerinas",
      "Boots",
      "Sports shoes",
      "Beach shoes",
      "Bridal shoes",
      "House Shoes",
      "Outdoor shoes",
      "Hats",
      "Scarves & Wraps",
      "Suits",
      "Bodysuits",
      "Coats, Jackets & Gilets",
      "Dungarees",
      "Leggings",
      "Jeans",
      "Shorts",
      "Skirts",
      "Jumpers, Cardigans & Sweatshirts",
      "Maternity",
      "Swimwear",
    ],
  },
  {
    id: 2,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0e42ef9c8-1488-4c86-9a4d-a3722ed00ffc",
    title: "Tools and DIY",
    cat: "diy-and-tools",
    desc: "Tool hire including drills, hedge trimmers, power tools, carpet cleaners. Search for your next tool rental. ",
    subcat: [
      "Power Tools",
      "Flooring and Tiling",
      "Mowers & Outdoor Power Tools",
      "Painting Equipment and Tools",
      "Building Tools",
      "Plumbing Tools",
      "Construction Machinery",
      "Electrical",
      "Hardware",
      "Plumbing Tools",
      "Sawing and Cutting",
      "Measuring Instruments",
      "Sanding",
      "Milling and Planing",
      "Welder",
      "Scaffolding",
      "Protective equipment",
      "Compressed Air",
    ],
  },
  {
    id: 20,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0ac154b1c-dce5-44c5-bde9-5f44ee111a6d",
    title: "Electronics and Photo",
    cat: "electronics-and-photo",
    desc: "Rent cameras, lenses, speakers, TV and other electronics from major brands",
    subcat: [
      "Cameras",
      "Camera Lenses",
      "Tripods and Gimbals",
      "DSLR Cameras",
      "Mirrorless Cameras",
      "Camera Flash and Lights",
      "Compact Camera",
      "Camcorder",
      "Special Cameras",
      "Polaroid Camera",
      "Film Cameras",
      "Digital Cinema Cameras",
      "Stands & Rigs",
      "Photo Backgrounds",
      "Film Monitor",
      "Drones",
      "Teleprompters",
      "Car & Vehicle Electronics",
      "GPS, Finders & Accessories",
      "Headphones, Earphones & Accessories",
      "Hi-Fi and Home Audio",
      "Home Cinema, TV & Video",
      "Household Batteries, Chargers & Accessories",
      "Phones",
      "Portable Sound and Video",
      "Power Accessories",
      "Radio Communication",
      "Wearable Technology",
      "eBook Readers & Accessories",
    ],
  },
  {
    id: 6,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-028c5d5fd-c333-446e-8489-1de072b1790c",
    title: "Video Games and Consoles",
    cat: "video-games-and-consoles",
    desc: "Rent a gaming PC, Nintendo Switch, PS5 or Xbox and find games go with them.",
    subcat: [
      "Legacy Systems",
      "Nintendo Switch",
      "PC",
      "Mac",
      "Playstation 4",
      "Plasystation 5",
      "Xbox One",
      "Xbox Series X",
    ],
  },
  {
    id: 5,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-067769b39-408f-4062-b1bc-03faa1e60996",
    title: "Toys and Games",
    cat: "toys-and-games",
    desc: "Here you can rent toys, board games, baby toys, outdoor toys, card games and so much more.",
    subcat: [
      "Arts & Crafts",
      "Baby & Toddler Toys",
      "Building & Construction Toys",
      "Dolls & Accessories",
      "Dress-Up Accessories",
      "Educational Toys",
      "Electronic Toys",
      "Games",
      "Hobbies",
      "Jigsaws & Puzzles",
      "Musical Toy Instruments",
      "Novelty & Gag Toys",
      "Party Supplies",
      "Play Figures",
      "Play Vehicles",
      "Pretend Play",
      "Puppets & Puppet Theatres",
      "Remote- & App-Controlled Toys",
      "Soft Toys",
      "Sports Toys & Outdoor",
    ],
  },
  {
    id: 7,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-08082d191-d356-491a-881b-ff63e06d32f5",
    title: "Home and Kitchen",
    cat: "home-and-kitchen",
    desc: "Cooking and need a unique utensil or specific cookware? Rent kitchen appliances, home decoration, lighting and much more.",
    subcat: [
      "Arts & Crafts",
      "Artwork",
      "Bathroom",
      "Bedding & Linens",
      "Cleaning Equipment",
      "Cooking & Dining",
      "Furniture",
      "Home Accessories",
      "Indoor Lighting",
      "Kitchen & Home Appliances",
      "Storage & Organisation",
    ],
  },
  {
    id: 4,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0e475f4e6-ea3d-4a43-99c3-062d9c5d1292",
    title: "Mens Fashion",
    cat: "mens-fashion",
    desc: "Rent designer menswear and suits. Even find tuxedos to rent and designer shoes. Book by the day, week or month.",
    subcat: [
      "Suits & Blazers",
      "Activewear",
      "Coats, Jackets & Gilets",
      "Jeans",
      "Jumpers, Cardigans & Sweatshirts",
      "Shorts",
      "Snow & Rainwear",
      "Swimwear",
      "Tops, T-Shirts & Shirts",
      "Trousers",
      "Belts",
      "Eyewear & Accessories",
      "Hats & Caps",
      "Cufflinks & Shirt Accessories",
      "Sneakers",
      "Open shoes",
      "Lace-up shoes",
      "Loafers",
      "Business shoes",
      "Boots",
      "Sports shoes",
      "Outdoor shoes",
      "Slippers",
      "Shoe accessories",
      "Beach shoes",
    ],
  },

  {
    id: 8,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-065786535-283c-4deb-bca5-c7f86d14f5f9",
    title: "Jewellery and Watches",
    cat: "jewellery-and-watches",
    desc: "It shouldn't cost the earth to feel great about how you look. Rent jewellery and watches, feel wonderful, look stylish.",

    subcat: [
      "Necklaces",
      "Earrings",
      "Bracelets",
      "Charms",
      "Rings",
      "Watches",
    ],
  },
  {
    id: 9,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-00bd9a2e5-a7b4-49f3-a59b-eeafe9d5a353",
    title: "Novelty Fashion",
    cat: "novelty-fashion",
    desc: "Rent halloween costumes and fun, unique fashion items. Here you'll find funky t-shirts, masks, movie costumes and other fancy dress.",
    subcat: [
      "Halloween",
      "Band T-shirts",
      "Movie and Fan Apparel",
      "Wedding Clothing",
      "Work Wear and Uniforms",
      "Fancy Dress",
    ],
  },

  {
    id: 11,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-052458b60-59cf-4098-adb9-d1d25da1a0dd",
    title: "Luggage & Travel Gear",
    cat: "luggage-travel-gear",
    desc: "Whether you want to rent suitcases or a smart business bag for that important meeting, chances are someone on Rentoodle is lending one.",
    subcat: [
      "Accessories",
      "Backpacks",
      "Business & Laptop Bags",
      "Gym Bags",
      "Handbags & Shoulder Bags",
      "Messenger Bags",
      "School Bags, Pencil Cases & Sets",
      "Shopping Bags & Baskets",
      "Suitcases & Travel Bags",
      "Umbrellas",
      "Waist Packs",
      "Wallets, Card Cases & Money Organisers",
    ],
  },
  {
    id: 14,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-060cbec1c-57c8-4288-ac04-ad5988b30676",
    title: "Baby Equipment and Clothes",
    cat: "baby-equipment-clothes",
    desc: "Rent strollers and prams, bassinets and baby bouncers and even baby monitors and car seats. Find nearly everything baby-related here.",
    subcat: [
      "Strollers",
      "Car Seats",
      "Carriers",
      "Bouncers",
      "Baby Monitors",
      "Booties",
      "High Chairs",
      "First Walking Shoes",
      "Christening Gowns",
      "Sandals",
      "Slippers",
      "Trainers",
      "Water Shoes",
      "Accessories",
      "Bodysuits & One-Pieces",
      "Coats, Jackets & Gilets",
      "Dresses",
      "Dungarees",
      "Hoodies & Tracksuits",
      "Jeans",
      "Knitwear",
      "Leggings",
      "Outfits & Clothing Sets",
      "Shorts",
      "Swimwear",
      "Tops",
      "Trousers",
    ],
  },
  {
    id: 15,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-068dd1d22-4037-4fbc-a431-e4e0c023fc4d",
    title: "Sports and Outdoors",
    cat: "sports-and-outdoors",
    desc: "Rent a tent for a weekend adventure; grab a tennis racket or fishing pole for a sunday funday. Search outdoor rentals.",
    featuredCat: ["Camping and Tents", "Tennis", "Fishing", "Boats"],
    subcat: [
      "American Football",
      "Archery",
      "Badminton",
      "Ballet & Dancing",
      "Baseball",
      "Basketball",
      "Billiard, Snooker & Pool",
      "Boat (under 20 ft only)",
      "Bowling",
      "Boxing",
      "Bicycles",
      "Camping and Tents",
      "Climbing",
      "Cricket",
      "Darts",
      "Electric scooters",
      "Equestrian",
      "Fishing",
      "Fitness",
      "Football",
      "Golf",
      "Gym Bags",
      "Gymnastics",
      "Handball",
      "Hockey",
      "Lacrosse",
      "Martial Arts",
      "Netball",
      "Paintball",
      "Rugby",
      "Running",
      "Skates, Skateboards & Scooters",
      "Sports & Outdoor Clothing",
      "Sports & Outdoor Shoes",
      "Sports Sunglasses",
      "Sports Technology",
      "Squash",
      "Supporters Gear",
      "Table Tennis",
      "Tennis",
      "Volleyball",
      "Water Sports",
      "Winter Sports",
      "Wrestling",
    ],
  },
  {
    id: 16,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0fc5a2317-ae8c-4067-9d88-47f160c440bb",
    title: "Industrial Equipment",
    cat: "industrial-equipment",
    desc: "Rent a whacker plate, heaters, portable generators, trailers, safety gear and even rent raised access platforms and more",
    subcat: [
      "Air Con & Cooling",
      "Access Equipment",
      "Breaking & Drilling",
      "Building & Siteworks",
      "Cleaning",
      "Concreting & Compaction",
      "Garden & Landscaping",
      "Heating",
      "Lift & Shift (Lifting & Handling)",
      "Lighting",
      "Painting & Decorating",
      "Plumbing & Pipework",
      "Power",
      "Powered Access",
      "Pumping & Drying",
      "Safety, Ventilation & Extraction",
      "Sanding & Fixing",
      "Sawing & Cutting",
      "Surveying & Location",
      "Welding",
    ],
  },
  {
    id: 17,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-035ba84c2-0453-4cd7-ba51-04e8ab3dd139",
    title: "CDs and Vinyls",
    cat: "cds-and-vinyls",
    desc: "A wonderful world of vinyl records and CDs to rent, across a range of genres, such as RnB, Rock, Pop",
    subcat: [
      "Blu-Ray Audio",
      "Blues",
      "Box Sets",
      "Cassette",
      "Children's Music, Plays & Stories",
      "Christmas",
      "Classical",
      "Compilations",
      "Country",
      "DVD Audio",
      "Dance & Electronic",
      "Easy Listening",
      "Folk",
      "Hard Rock & Metal",
      "Indie & Alternative",
      "Jazz",
      "Miscellaneous",
      "Musicals & Cabaret",
      "Opera & Song",
      "Pop",
      "R&B and Soul",
      "Rap & Hip-Hop",
      "Reggae",
      "Rock",
      "SACD",
      "Singles",
      "Soundtracks",
      "Vinyl",
    ],
  },
  {
    id: 18,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-09f9f00ba-9aff-40b7-b929-2f86e3a3721a",
    title: "Computers and Accessories",
    cat: "computers-and-accessories",
    desc: "Rent tech like a printer for a day, PC monitors for your business, tablets peripheral tech devices. All from real people, near you.",
    subcat: [
      "Accessories",
      "Data Storage",
      "Desktops",
      "Laptops",
      "Monitors",
      "Networking Devices",
      "Printers & Accessories",
      "Scanners & Accessories",
      "Servers",
      "Tablets",
      "Cables",
      "eReaders",
    ],
  },
  {
    id: 19,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-01278187b-9ebd-4f94-bb7b-d553266fc190",
    title: "DVD and Blu-ray",
    cat: "dvd-and-blu-ray",
    desc: "Some DVDs are not yet streamable. Find DVD rentals and Blu-rays here.",
    subcat: [
      "Action & Adventure",
      "Animation",
      "Anime",
      "Blu-ray",
      "Blu-ray 3D",
      "Bollywood",
      "Box Sets",
      "Children & Family",
      "Comedy",
      "Crime",
      "Documentary",
      "Drama",
      "Exercise & Fitness",
      "Fantasy",
      "Gay, Lesbian & Transgender",
      "Historical",
      "Horror",
      "Military & War",
      "Music Video & Concert",
      "Musical",
      "Performing Arts",
      "Reality TV",
      "Romance",
      "Science Fiction",
      "Special Interest",
      "Sport",
      "Stand-Up Comedy",
      "Steelbook",
      "TV",
      "Thriller",
      "Western",
      "World Cinema",
    ],
  },
  {
    id: 21,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0a2a56fa1-35b9-494e-abfc-39112e87c52d",
    title: "Garden Tools",
    cat: "garden",
    desc: "Rent garden tools, as well as find BBQs, garden furniture, lawnmowers, hot tubs and more garden-related rentals available.",
    subcat: [
      "Barbecue & Outdoor Dining",
      "Bird & Wildlife Care",
      "Decking & Fencing",
      "Garden Décor",
      "Garden Furniture & Accessories",
      "Garden Storage & Housing",
      "Garden Tools & Watering Equipment",
      "Gardening",
      "Mowers & Outdoor Power Tools",
      "Outdoor Heaters & Fire Pits",
      "Outdoor Lighting",
      "Plants, Seeds & Bulbs",
      "Pools, Hot Tubs & Supplies",
      "Thermometers & Meteorological Instruments",
    ],
  },
  {
    id: 22,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0b4f59354-fa3b-4b66-92e0-4b3a81ffba85",
    title: "Appliances",
    cat: "appliances",
    desc: "Rent Washing machines from reputable lenders, dishwashers, rent fridges, microwaves, steam ovens and more.",
    subcat: [
      "Beer & Wine Storage & Dispensers",
      "Beverage Refrigerators",
      "Combined Ovens & Hobs",
      "Dishwashers & Dish Dryers",
      "Freezers",
      "Hobs",
      "Hoods",
      "Installed Ovens",
      "Microwave Ovens",
      "Mini Freezers",
      "Mini Fridges",
      "Range Ovens",
      "Standard Refrigerators",
      "Steam Ovens",
      "Warming Drawers",
      "Washing Machines & Tumble Dryers",
    ],
  },
  {
    id: 23,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0374b0b35-3f31-4973-bc46-2fa0488bdba9",
    title: "Lighting",
    cat: "lighting",
    desc: "Rent lighting equipment from LEDs, feature lighting, outdoor lighting, even find garden lighting for your event.",
    subcat: [
      "Bathroom Lighting",
      "Holiday Lighting",
      "Indoor Lighting",
      "Light Bulbs",
      "Outdoor Lighting",
      "Rope Lights",
      "String Lights",
      "Torches",
      "Christmas Lights",
    ],
  },
  {
    id: 24,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-04468cd4d-1e26-4191-a0e0-206a971a127d",
    title: "Musical Instruments and DJ",
    cat: "musical-instruments-and-dj",
    desc: "Rent musical instruments from microphones to DJ equipment. Trying out guitars, throwing a karaoke party - rent the music equipment you need it.",
    subcat: [
      "Microphones",
      "Speakers",
      "Bass Guitars & Gear",
      "DJ & VJ Equipment",
      "Drums & Percussion",
      "General Music-Making Accessories",
      "Guitars & Gear",
      "Karaoke Equipment",
      "PA & Stage",
      "Piano & Keyboard",
      "Recording & Computer",
      "String Instruments",
      "Synthesizer & Sampler",
      "Wind Instruments",
    ],
  },
  {
    id: 25,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0c7e8e2f7-b743-4f38-bcd4-dda79aefa8b5",
    title: "Pet Supplies",
    cat: "pet-supplies",
    desc: "Rent pet-related items like horse boxes or even dog toys to give your furry friends a change of fun! Also find dog harnesses, car seats, fish bowls, rent a cat or dog cage for travel requirements amongst other things",
    subcat: [
      "Bird & Wildlife Care",
      "Birds",
      "Cats",
      "Dogs",
      "Fish & Aquatic Pets",
      "Horses",
      "Insects",
      "Reptiles & Amphibians",
      "Small Animals",
    ],
  },
  {
    id: 26,
    img: "https://kabeeb.s3.eu-west-2.amazonaws.com/620e0f79a3b3dd3762c63cf5-0ee1861b0-0571-429c-98b5-95b05cf55f2a",
    title: "Office Supplies",
    cat: "office-supplies",
    desc: "Rent office equipment like filing cabinets, projectors, staplers, printers, ornaments, art work, whiteboards etc.",
    subcat: [
      "Art & Craft Supplies",
      "Furniture & Lighting",
      "Office Electronics",
      "Pens, Pencils & Writing Supplies",
      "School & Educational Supplies",
    ],
  },
];

export const descriptors = [
  {
    id: 0,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/borrow-books-02e984945-d5df-4809-87b6-8e06a88b2831",
    alt: "Borrow Books",
    headline: "Borrow Books",
    subCat: "Borrow Books",
    desc: "Borrow books from people in the UK or near to you. Find textbooks and reading books in nearly every genre, below, or search.",
  },
  {
    id: 1,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/Michael-Kors-Stretch-Knit-Midi-Dress-0ffddd933-49c6-482a-8306-fa640a691bf9",
    alt: "Rent designer dresses",
    headline: "Rent Designer Dresses",
    subCat: "Designer Dresses",
    desc: "Rent designer dresses from people in the UK or near to you. Find midi dresses, open back or long sleeve dresses and search for brands you know and love, like Michael Kors, Gucci, Stella McCartney and more.",
  },

  {
    id: 2,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/test-25688c535-b769-42d1-8ac0-cfc1eaa5597c",
    alt: "Camera Hire",
    headline: "Camera Hire",
    subCat: "Cameras",
    desc: "Rent cameras from people in the UK or nearby. Find DSLR cameras for hire and camera lenses from leading brands or rent tripods, and lighting for your photoshoot. Hire everything you need to bring your creative photography ideas to life.",
  },
  {
    id: 3,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/delete-01c7d2563-271a-454a-a30b-63c611b88334",
    alt: "Rent Designer Handbags",
    headline: "Rent Designer Handbags",
    subCat: "Designer Handbags",
    desc: "Rent designer handbags from people in the UK or near to you. Find clutch bags, mini handbags and other luxury bags available to rent. Search for brands you know and love, like Michael Kors, Gucci, Hermes and more.",
  },
  {
    id: 4,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/Michael-Kors-Stretch-Knit-Midi-Dress-0ffddd933-49c6-482a-8306-fa640a691bf9",
    alt: "rent designer clothes",
    headline: "Rent Designer Clothes",
    subCat: "Womens Fashion",
    desc: "Rent designer clothes from people in the UK or near to you. Find accessories, dresses, handbags, suits and search for brands you know and love, like Dior, Prada, Valentino and more.",
  },
  {
    id: 5,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/delete-017a423cd-32fc-470f-bd82-2db7630408ac",
    alt: "rent baby clothes",
    headline: "Rent Baby Clothes and Equipment",
    subCat: "Baby Equipment and Clothes",
    desc: "Babies grow quickly - rent baby clothes for boys and girls, from people who share their things on Rentoodle. Find and rent baby strollers and baby bouncers, or even baby high chairs when you need them.",
  },
  {
    id: 6,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/delete-1ca1a0cde-15ee-46b5-b1ac-1354ec429140",
    alt: "rent kitchen equipment and homeware",
    headline: "Rent Kitchen Equipment and Homeware",
    subCat: "Home and Kitchen",
    desc: "Search for things you can rent around the home, shared by from people in the UK. Borrow things like pasta machines, find furniture hire or rent home equipment like nespresso machines and vacuum cleaners. ",
  },
  {
    id: 7,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/delete-2ec333b16-cf52-4cd5-94b6-6fa6fb53fc02",
    alt: "rent tools",
    headline: "Rent Tools",
    subCat: "Tools and DIY",
    desc: "Hire tools from people in the UK or pickup and rent tools locally. It's quick and easy to find a tool rental on Rentoodle. Find tools like sanders, pressure washers, hire a drill or a whacker plate, all local to you, from people just like you.",
  },
  {
    id: 8,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-video-games-0b3400cb5-1afa-4e18-b498-89a69dbbb54c",
    alt: "rent video games",
    headline: "Rent Video Games & Consoles",
    subCat: "Video Games and Consoles",
    desc: "Rent video games from people in the UK or pickup and rent games consoles locally. It's quick and easy to rent Xbox, Nintendo or Playstation games on Rentoodle.",
  },
  {
    id: 9,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-hire-073c81791-2ad0-4df5-aabb-916c90155abe",
    alt: "rent toys",
    headline: "Rent Toys and Children's Games",
    subCat: "Toys and Games",
    desc: "Rent toys for children. Find exciting toys for your kids like Didi Car hire and lego rentals. Borrow the latest toy from people in the UK, return it and rent another toy next week!",
  },
  {
    id: 10,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-hire-179d965d4-da7d-4d57-bc94-adf4b497efbb",
    alt: "suit hire",
    headline: "Mens Suit Hire and Designer Fashion Rental",
    subCat: "Mens Fashion",
    desc: "Find a tuxedo hire or to rent a suit from people in the UK. Save money and hire a suit that looks fantastic but doesn't cost the earth, whether it's for a wedding, prom or work.",
  },
  {
    id: 11,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-hire-2ec379a12-a8f6-4fd9-93bf-e1c9f563f588",
    alt: "rent jewellery",
    headline: "Rent Jewellery",
    subCat: "Jewellery and Watches",
    desc: "Rent jewellery and designer watches. Rent Rolex watches, Van Cleef and Arpels necklaces, Dior bracelets and Chanel jewellery rentals from people in the UK.",
  },
  {
    id: 12,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-hire-0a25f665e-b04d-4ece-91ee-b86c0e62ce15",
    alt: "rent fancy dress",
    headline: "Fancy Dress Rental and Costume Hire",
    subCat: "Novelty Fashion",
    desc: "Rent Fancy dress and costumes for events and special occassions. Hire costumes for halloween and birthdays etc. from people in the UK.",
  },
  {
    id: 13,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-hire-006947006-9d19-4555-b228-3832d10d6e27",
    alt: "rent roof bars and luggage",
    headline: "Rent Luggage Gear",
    subCat: "Luggage & Travel Gear",
    desc: "Hire roof bars for your vehicle or find a suitcase rental from people in the UK",
  },
  {
    id: 14,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/rent-hire-0c6fd183d-ae66-48f8-82c3-0f6f74661907",
    alt: "rent golf clubs and camping equipment",
    headline: "Sports Gear Rentals and Camping Hire",
    subCat: "Sports and Outdoors",
    desc: "Rent golf clubs and outdoor camping hire from people in the UK. Find tents to hire and take equipment on your next camping trip in the UK, or rent a golf club or skis that you need for weekend away.",
  },
  {
    id: 15,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-025a6efcc-3475-4741-bb03-7ba1b60e0a83",
    alt: "rent construction tools",
    headline: "Rent Construction Equipment",
    subCat: "Industrial Equipment",
    desc: "Rent Pressure washers, carpet cleaners and hire construction equipment from people in the UK or local collection nearby.",
  },
  {
    id: 16,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-195a4f3cb-3e51-405a-9f3b-80e20b4e832a",
    alt: "rent vinyl records",
    headline: "Rent Vinyl Records and CDs",
    subCat: "CDs and Vinyls",
    desc: "Rent vinyls and vinyl record players from people in the UK or nearby. Try searching for the vinyl you're looking to rent.",
  },
  {
    id: 17,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-235485cab-599f-4f7e-936e-22eb2b7fc878",
    alt: "rent ",
    headline: "Rent Laptops, VR Headsets and more",
    subCat: "Computers and Accessories",
    desc: "Rent VR headsets, gaming PCs and laptops from people in the UK. Find a macbook rental, computer or monitor for when you need it.",
  },
  {
    id: 18,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-36fbe35e1-fbd6-4082-8ae7-cc5c2ab062df",
    alt: "rent DVDs",
    headline: "Rent DVDs",
    subCat: "DVD and Blu-ray",
    desc: "Rent DVDs that may be unavailable to stream. Nothing beats renting a DVD and slotting it into your home cinema set up. Find DVD rentals from people in the UK.",
  },
  {
    id: 19,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-410a2de3c-ab4c-476a-a839-f5b9459b0015",
    alt: "garden tool hire",
    headline: "Garden Tool Hire",
    subCat: "Garden Tools",
    desc: "Hire a lawn mower and hire a strimmer or hedge cutter from people in the UK. Find lawn aerators, hire garden rollers and almost every other garden equipment you need to rent.",
  },
  {
    id: 20,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-53993f526-0c13-40e1-b84f-c5669f6dbc55",
    alt: "rent washing dryers and appliances",
    headline: "Rent Appliances",
    subCat: "Appliances",
    desc: "Rent household appliances such as whitegoods like washing machines, dryers and fridges. Grab a freezer rental or dishwasher, or even rent a pizza oven for a special occasion. Find applances to rent from people in the UK.",
  },
  {
    id: 21,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-0adc53d5b-1dbb-4fa1-b5ba-36ff6399e7c0",
    alt: "rent lighting",
    headline: "Rent Lighting",
    subCat: "Lighting",
    desc: "Hire tower lighting, theatrical lights or spotlight rental for your photography or stage needs. Have a dance event or disco and need the lights? Rent lighting from people in the UK.",
  },
  {
    id: 22,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-2e40ede9c-8ccb-4392-a56f-9b986766425a",
    alt: "rent DJ equipment",
    headline: "Music & DJ Equipment Rental",
    subCat: "Musical Instruments and DJ",
    desc: "Rent DJ equipment and find musical instrument rentals from people in the UK. Hire a drum kit or rent a guitar people just like you.",
  },
  {
    id: 23,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-0a92305ff-6b86-4e6b-b92f-9c84055cb196",
    alt: "pet clothes and dog toys",
    headline: "Borrow Things for your pet",
    subCat: "Pet Supplies",
    desc: "Treat your beautiful pets with a new toy! Rent dog clothes, pet toys and dog cages or cat carriers from people nearby and throughout the UK. Find things you can rent for your beloved pet.",
  },
  {
    id: 24,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-3d927b46b-75f8-4487-84ba-b346bf01f954",
    alt: "rent a printer",
    headline: "Rent Office Equipment",
    subCat: "Office Supplies",
    desc: "Rent a printer, a photocopier or even a stapler from people in the UK or local to you.",
  },
  {
    id: 25,
    img: "https://rentoodle-public.s3.eu-west-2.amazonaws.com/hire-rent-0fa5153ad-2305-4396-99cd-cb8f4d7ce08e",
    alt: "rent electronics and photography gear",
    headline: "Lens Hire, Camera Rentals and more",
    subCat: "Electronics and Photo",
    desc: "Hire cameras rent audio equipment, rent speakers or even microwaves and other electronics - all from people in the UK or pickup nearby.",
  },
  {
    id: 26,
    img: "",
    alt: "home staging is easy with furniture rental",
    headline: "Rent Furniture & Home Staging",
    subCat: "Furniture",
    desc: "Stage your home and rent furniture from people nearby or across the UK. Home staging for your living room, dining room, bedrooms and more is easy on Rentoodle. ",
  },
];
